import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=65c5fd75&"
import script from "./Sector.vue?vue&type=script&lang=ts&"
export * from "./Sector.vue?vue&type=script&lang=ts&"
import style0 from "./Sector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports